import {BaseContainerModel} from "../../base-container.model";
import {
  bl_wf_mail_handler_RowInterface,
  bl_wf_mail_handler_RowClass
} from "../../../dbschema";

export class WfMailHandlerContainerModel extends BaseContainerModel {
  bl_wf_mail_handler: bl_wf_mail_handler_RowInterface = new bl_wf_mail_handler_RowClass();
}
